import styled from 'styled-components';
import { fontSize, screen } from 'theme';
import FlexibleWrapper from 'components/shared/FlexibleWrapper/FlexibleWrapper';
import { ButtonLink } from '@asgard/ui-library';

const Root = styled.div`
  background-color: #fbedff;
  color: #092c61;
  padding: 4rem 0 5rem 0;
  font-size: ${fontSize('lg')};

  .titles {
    flex-direction: column-reverse;
  }
`;

const OuterWrapper = styled(FlexibleWrapper).attrs({
  imagePath: '/images/common/irregular-box-4.svg',
  backgroundColor: 'var(--surface-auxiliary-3-level-02-background, #DCB4E8)'
})`
  margin: auto 1rem;
  padding-top: clamp(3rem, 5vw, 6rem);
  padding-bottom: clamp(3rem, 5vw, 6rem);
  padding-left: clamp(3rem, 5vw, 6rem);
  padding-right: clamp(3rem, 5vw, 6rem);

  @media (max-width: ${screen('md2')}) {
    padding-bottom: clamp(4rem, 5vw, 6rem);
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 100%;
  color: #52105e;
  text-align: center;

  p {
    margin: 0;
  }

  h1 {
    font-size: clamp(${fontSize('lg')}, 4vw, ${fontSize('xl3')});
    font-weight: 800;
    text-wrap: balance;
    margin: 0 0 1.5rem 0;
  }

  img {
    margin: 0 auto;
    max-width: 100%;
  }

  br {
    display: none;
  }

  @media (min-width: ${screen('md2')}) {
    flex-direction: row;
    align-items: center;
    gap: 3rem;
    max-width: 100%;
    margin-top: 0;
    margin-bottom: clamp(3rem, 5vw, 6rem);
    text-align: left;

    & > * {
      flex: 1;
      min-width: 0;
    }

    h1 {
      font-size: clamp(${fontSize('xl3')}, 3vw, ${fontSize('xl5')});
      margin-top: 3rem;
    }

    br {
      display: block;
    }

    img {
      max-width: 100%;
      height: auto;
    }
  }

  @media (min-width: ${screen('xl')}) {
    h1 {
      font-size: clamp(${fontSize('xl3')}, 3vw, ${fontSize('xl5')});
    }
  }
`;

const CTAs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: ${screen('xl')}) {
    flex-direction: column;
  }
`;

const StyledButtonLink = styled(ButtonLink)`
  & > span:last-child > span {
    white-space: normal;
    font-size: clamp(${fontSize('xs')}, 1.2vw, ${fontSize('sm')});
  }
`;

export const HeroStyles = {
  Root,
  OuterWrapper,
  Content,
  CTAs,
  StyledButtonLink
};
